export enum FlexBoxJustifyContent {
  /**
   * Items are aligned toward the start of the flex-direction.<br />
   * <b>Note:</b> Corresponds to `flex-start`.
   */
  Start = 'Start',
  /**
   * Items are centered.<br />
   * <b>Note:</b> Corresponds to `center`.
   */
  Center = 'Center',
  /**
   * Items are aligned toward the end of the flex-direction.<br />
   * <b>Note:</b> Corresponds to `flex-end`.
   */
  End = 'End',
  /**
   * Items are evenly distributed on the main-axis with equal space around them.<br />
   * <b>Note:</b> Corresponds to `space-around`.
   */
  SpaceAround = 'SpaceAround',
  /**
   * Items are evenly distributed on the main-axis; first item is on the start line, last item on the end line.<br />
   * <b>Note:</b> Corresponds to `space-between`.
   */
  SpaceBetween = 'SpaceBetween'
}
